module.exports = __webpack_public_path__ + "assets/images/all-notifications.png";


//////////////////
// WEBPACK FOOTER
// ./app/components/notifications/all-notifications.png
// module id = pKWn
// module chunks = 1